import Approved from "../images/approved.svg";
import { Card, Container, Content } from "../styles";

export function ApprovedComponent() {
  return (
    <Container>
      <Content>
        <img className="img" src={Approved} alt="Card bloqueado" />
        <Card noPadding size="lg" background="#6C5AF4" color="#ffffff">
          <div style={{ width: "100%" }}>
            <h2 style={{ fontWeight: "700" }}>Você está quase lá!</h2>
            <h2 style={{ width: "100%" }}>
              Recebemos suas informações para cadastro e, em breve, entraremos
              em contato para <br /> concluir seu contrato com a AXS!
            </h2>
          </div>
        </Card>

        <span>
          Qualquer dúvida sobre o processo de contratação, basta entrar em
          contato com o nosso setor de <br /> atendimento através do e-mail{" "}
          <a
            href="mailto:atendimento@axsenergia.com.br"
            target="_blank"
            rel="noreferrer"
          >
            atendimento@axsenergia.com.br
          </a>{" "}
          ou telefone (WhatsApp){" "}
          <a
            href="https://api.whatsapp.com/send/?phone=%2B5508007003434&text=Ol%C3%A1%2C+quero+saber+mais+sobre+energia+renov%C3%A1vel.&type=phone_number&app_absent=0"
            target="_blank"
            rel="noreferrer"
          >
            0800 700 3434
          </a>
          .{" "}
        </span>
      </Content>
    </Container>
  );
}
